import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/category/chronic-pain")({
  beforeLoad: () => {
    throw redirect({ to: "/chronic-pain-coral-springs-fl" });
  },
});
